/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop, .search-area a.search-icon';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  Utils.buildProductItemUrl = function(data, hasCollection) {
    // console.log('buildProductItemUrl');
    // Get url information
    var params = Utils.getWindowLocation().search.substring(1);
    var pathname = window.location.pathname;
    var elements = pathname.split('/');
  
    // Check if has locale
    var localeURLPart = "";
    var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
      localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    }
  
    // Get product handle
    var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    if (hasCollection) {
      // Homepage or Search page
      if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
        var preHandle = localeURLPart + '/collections/all/products/';
        return preHandle + handle;
  
        // Tag Page
      } else if (Utils.isTagPage()) {
        var preHandle = localeURLPart + '/collections/';
        var collectionHandleIndex = elements.indexOf("collections") + 1
        if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
        return '/collections/all/products/' + handle;
      } else {
        // Google cache URL
        // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
        if (params.indexOf('cache:') > -1) {
          var collectionHandle = 'all';
          var temp = params.split('&')[0].split('?')[0].split('collections/');
          if (temp.length > 1) {
            if (temp[1].indexOf('/') > -1) {
              collectionHandle = temp[1].split('/')[0];
            } else {
              collectionHandle = temp[1];
            }
          }
          collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
          return '/collections/' + collectionHandle + '/products/' + handle;
        }
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        var preHandle = localeURLPart + '/collections/';
        
        if (typeof elements[2] !== 'undefined') {
          // Build for collection pages
          if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
            return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          }
          //Build for other pages, use collection/all
          return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
        } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
          return '/products/' + handle;
        }
        return window.location.pathname + '/products/' + handle;
      }
    }
    return localeURLPart + '/products/' + handle;
  };
  
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function(){
   	// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		var price;
    // Format price
     if(boostPFSAppConfig.general.current_currency == 'EUR') {
         price = Utils.formatMoney(this.data.price_min_eur);
     }else {
        price = Utils.formatMoney(this.data.price_min);
     }
    
    
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
  }
  
  
  
})();